<input
  class="input-box form__control"
  angular-mydatepicker
  name="mydate"
  [id]="labelId"
  [options]="datepickerOptions"
  readonly="readonly"
  (click)="toggleCalendar($event)"
  (dateChanged)="change($event)"
  [(ngModel)]="model"
  [ngClass]="{ 'disable-focus': datepickerReadOnly, noIcon: disableDatepickerIcon }"
  #mydatepicker="angular-mydatepicker"
/>
